{
  "id": "ranged",
  "role": "ranged",
  "speed": 88,
  "cost": {
    "gold": 70,
    "lumber": 20
  },
  "trainTicks": 140,
  "supply": 1,
  "hp": 40,
  "builds": [],
  "combat": {
    "damage": 6,
    "range": 4,
    "cooldownTicks": 25,
    "acquireRange": 5
  }
}
